<ng-container *ngIf="unRedeemedItems?.length > 0; else noWalletItems">
  <h2 class="mb-2 mt-0 rewards-wallet-redeem-title">{{ 'rewards.wallet.redeem.title' | translate }}</h2>
  <owl-carousel-o [options]="customOptions" (dragging)="isDragging = $event.dragging">
    <ng-container *ngFor="let groupedItem of unRedeemedItems">
      <ng-template [width]="305" carouselSlide>
        <fgbcl-rewards-wallet-redeem-list-item
          [item]="groupedItem?.items[0]"
          [stopLink]="isDragging"
          [multi]="groupedItem.multi"
          owlRouterLink="{{ getItemDetailUrl(groupedItem?.items[0]) }}"
          [showButton]="true"
        ></fgbcl-rewards-wallet-redeem-list-item>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</ng-container>

<ng-template #noWalletItems>
  <div class="wallet-placeholder">
    <h5 class="no-wallet-items fw-bold">{{ 'rewards.wallet.no.items' | translate }}</h5>
    <div class="no-items m-0 no-results-placeholder-div pt-5 pb-4">
      <div class="svg svg-info vs-svg ms-auto me-auto" fgbAnimateSvg [inlineSVG]="'assets/images/placeholders/Wallet.svg'"></div>
      <div class="no-results-placeholder p-3 text-center">{{ 'rewards.wallet.no.items.description' | translate }}</div>
    </div>
  </div>
</ng-template>
